/*  ===================================
 *  TIER PROGRESS WIDGET
 *  - Complicated widget that adds a progress bar indicating how far they are for various tiers
 *  ===================================
 */

(function(w,d){
    const settings = {
        container: 'TPContainer',
        progress_bar: 'TPBar',
        message: 'TPMessage',
        message_error: 'Please enter a target goal amount in the Theme Settings > Cart > Free Shipping Threshold'
    }
    const container = d.getElementById(settings.container);
    let data;
    let exchange_rate = Shopify.currency.rate;
    console.log({exchange_rate})

    function convertCurrency(amount) {
        return (amount * exchange_rate).toFixed(2);
    }

    function initData() {
        // dataset
        const dataset = container.dataset.settings ?? new Object;
        if (Object.keys(dataset).length === 0) return;
        data = JSON.parse(dataset);

        // json settings
        const raw_json = container.querySelector('#TPContainer-data');
        if (!raw_json) return;
        const json = JSON.parse(raw_json.innerText);

        // merge data
        data = {...data, ...json};
    }

    function fetchCartData() {
        fetch((window.theme.routes.cart ? window.theme.routes.cart : '/cart.js'), {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => {
            calculateProgress(data);
            document.querySelector('#CartDrawer-ItemCount').innerHTML = data.item_count;
        });
    }

    async function organiseData() {
        const dataset = [];
        for (let i = 0; i < 4; i++) {
            const prefix = `tp_${i+1}`;

            if (data[`${prefix}_target`] != "" && parseInt(data[`${prefix}_target`])) {
                dataset.push({
                    "tier": i+1,
                    "target": parseInt(data[`${prefix}_target`]) * 100,
                    "shipping": data[`${prefix}_shipping`],
                    "message_ongoing": data[`${prefix}_message_ongoing`],
                    "message_success_unclaimed": data[`${prefix}_message_success_unclaimed`],
                    "message_success_claimed": data[`${prefix}_message_success_claimed`],
                    "products": data[`${prefix}_products`]
                })
            }
        }
        dataset.sort((a, b) => a.target - b.target);

        return dataset;
    }

    async function renderElements() {
        const labelHTML = d.createElement('label')
        labelHTML.setAttribute('for', settings.progress_bar)

        const progressBarHTML = d.createElement('progress')
        progressBarHTML.id = settings.progress_bar
        progressBarHTML.setAttribute('max', 100)
        progressBarHTML.setAttribute('value', 0)

        const progressBarWrapper = d.createElement('div')
        progressBarWrapper.classList.add('tp-progress-bar-wrapper')
        progressBarWrapper.appendChild(progressBarHTML)

        const messageHTML = d.createElement('div')
        messageHTML.id = settings.message
        messageHTML.classList.add('tp-message')

        container.appendChild(labelHTML);
        container.appendChild(progressBarWrapper);
        container.appendChild(messageHTML);
    }

    function removeGiftsFromCart(key_array) {
        let updates = {};

        key_array.forEach(key => {
            updates[key] = 0;
        })

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
        .then(async response => {
            document.dispatchEvent(new CustomEvent('cart:build'));
            const cart = await fetchCart();
            document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                    cart: cart
                }
            }));
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    async function calculateProgress(cartJson) {
        // First, remove any non discounted gifts
        const items = cartJson.items

        const itemsToRemove = [];
        items.forEach(item => {
            if (item.properties?.["_giftTier"] && item.final_price > 0) {
                itemsToRemove.push(item.key);
            }
        })

        if (itemsToRemove.length) {
            removeGiftsFromCart(itemsToRemove);
            return;
        }

        let canClaimGift = false;

        let claimedGifts = [];
        cartJson.items.forEach(item => {
            if (item.properties?.["_giftTier"]) {
                claimedGifts.push(item.properties["_giftTier"]);
            }
        })

        const full_dataset = await organiseData();
        const cartTotal = cartJson.total_price;

        // append all targets to progressBarWrapper
        const wrapper = document.querySelector('.tp-progress-bar-wrapper');
        // as this runs on cart update we can skip it after the first instance
        if (!wrapper.querySelector('.tp-progress-bar__target')) {
            const highest_target = full_dataset[full_dataset.length - 1].target;
            const present_icon = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.2 5V8.76C8.2 8.79152 8.19379 8.82273 8.18173 8.85184C8.16967 8.88096 8.15199 8.90742 8.12971 8.92971C8.10742 8.95199 8.08096 8.96967 8.05184 8.98173C8.02273 8.99379 7.99152 9 7.96 9H2.04C2.00848 9 1.97727 8.99379 1.94816 8.98173C1.91904 8.96967 1.89258 8.95199 1.87029 8.92971C1.84801 8.90742 1.83033 8.88096 1.81827 8.85184C1.80621 8.82273 1.8 8.79152 1.8 8.76V5M5 9V3M5 3H3.2C2.93478 3 2.68043 2.89464 2.49289 2.70711C2.30536 2.51957 2.2 2.26522 2.2 2C2.2 1.73478 2.30536 1.48043 2.49289 1.29289C2.68043 1.10536 2.93478 1 3.2 1C4.6 1 5 3 5 3ZM5 3H6.8C7.06522 3 7.31957 2.89464 7.50711 2.70711C7.69464 2.51957 7.8 2.26522 7.8 2C7.8 1.73478 7.69464 1.48043 7.50711 1.29289C7.31957 1.10536 7.06522 1 6.8 1C5.4 1 5 3 5 3ZM8.76 3H1.24C1.17635 3 1.1153 3.02529 1.07029 3.07029C1.02529 3.1153 1 3.17635 1 3.24V4.76C1 4.82365 1.02529 4.8847 1.07029 4.92971C1.1153 4.97471 1.17635 5 1.24 5H8.76C8.82365 5 8.8847 4.97471 8.92971 4.92971C8.97471 4.8847 9 4.82365 9 4.76V3.24C9 3.17635 8.97471 3.1153 8.92971 3.07029C8.8847 3.02529 8.82365 3 8.76 3Z" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            const shipping_icon = `<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0.875V1.5H5.9375V6.1875H4.01375C3.87437 5.65031 3.39125 5.25 2.8125 5.25C2.23375 5.25 1.75063 5.65031 1.61125 6.1875H1.25V4.625H0.625V6.8125H1.61125C1.75063 7.34969 2.23375 7.75 2.8125 7.75C3.39125 7.75 3.87437 7.34969 4.01375 6.8125H6.61125C6.75063 7.34969 7.23375 7.75 7.8125 7.75C8.39125 7.75 8.87438 7.34969 9.01375 6.8125H10V4.26375L9.98031 4.21469L9.35531 2.33969L9.2875 2.125H6.5625V0.875H0ZM0.3125 2.125V2.75H3.125V2.125H0.3125ZM6.5625 2.75H8.83781L9.375 4.35156V6.1875H9.01375C8.87438 5.65031 8.39125 5.25 7.8125 5.25C7.23375 5.25 6.75063 5.65031 6.61125 6.1875H6.5625V2.75ZM0.625 3.375V4H2.5V3.375H0.625ZM2.8125 5.875C3.16156 5.875 3.4375 6.15094 3.4375 6.5C3.4375 6.84906 3.16156 7.125 2.8125 7.125C2.46344 7.125 2.1875 6.84906 2.1875 6.5C2.1875 6.15094 2.46344 5.875 2.8125 5.875ZM7.8125 5.875C8.16156 5.875 8.4375 6.15094 8.4375 6.5C8.4375 6.84906 8.16156 7.125 7.8125 7.125C7.46344 7.125 7.1875 6.84906 7.1875 6.5C7.1875 6.15094 7.46344 5.875 7.8125 5.875Z" fill="black"/></svg>`;
            
            for (let i = 0; i < full_dataset.length; i++) {
                const tier = full_dataset[i];
                if (!tier.products && !tier.shipping) continue;

                const position = (tier.target / highest_target) * 100;
    
                const target_icon = document.createElement('div');
                target_icon.classList.add('tp-progress-bar__target', `tp-progress-bar__target--${i+1}`);
                let html = `
                    <span>
                `;
                if (tier.products) {
                    html += present_icon
                }
                if (tier.shipping) {
                    html += shipping_icon
                }
                html += `
                    </span>
                    <span>${data.cart_currency_symbol ?? '$'}${convertCurrency(tier.target / 100)}</span>
                `;
    
                target_icon.innerHTML = html;
    
                target_icon.style.left = `${position}%`;
    
                wrapper.appendChild(target_icon);
            }
        }
        
        const giftProductWrappers = document.querySelectorAll('.cart__tpgp-gift-tier');
        const activeTiers = [];

        let nextTarget_val = full_dataset[0].target;
        let nextTarget_index = 0;
        let message = '';

        for (let i = 0; i < full_dataset.length; i++) {
            const t = full_dataset[i].target;
            const r = t - cartTotal;

            nextTarget_index = i;
            nextTarget_val = t;

            if (t <= cartTotal) {
                canClaimGift = true;
                activeTiers.push(i+1);

                if (claimedGifts.includes(i+1)) {
                    message += `
                        <p>${(full_dataset[nextTarget_index].message_success_claimed).replace('[target]', `${data.cart_currency_symbol ?? '$'}${convertCurrency(t / 100)}`).replace('[remaining]', `${data.cart_currency_symbol ?? '$'}${convertCurrency(r / 100)}`)}</p>
                    `;
                } else {
                    message += `
                        <p>${(full_dataset[nextTarget_index].message_success_unclaimed).replace('[target]', `${data.cart_currency_symbol ?? '$'}${convertCurrency(t / 100)}`).replace('[remaining]', `${data.cart_currency_symbol ?? '$'}${convertCurrency(r / 100)}`)}</p>
                    `;
                }
            }

            if (t > cartTotal) {
                message += `
                    <p>${(full_dataset[i].message_ongoing).replace('[target]', `${data.cart_currency_symbol ?? '$'}${convertCurrency(t / 100)}`).replace('[remaining]', `${data.cart_currency_symbol ?? '$'}${convertCurrency(r / 100)}`)}</p>
                `;
                break; // escape as soon as we find a bigger target
            }
        }

        // Show/hide tier
        giftProductWrappers.forEach(tier => {
            tier.classList.add('hidden');
            activeTiers.forEach(num => {
                if (tier.classList.contains(`cart__tpgp-gift-tier--${num}`)) {
                    tier.classList.remove('hidden');
                }
            })
        })

        const targs = document.querySelectorAll('.tp-progress-bar__target');
        targs.forEach(targ => {
            let isActive = false;
            activeTiers.forEach(num => {
                if (targ.classList.contains(`tp-progress-bar__target--${num}`)) {
                    isActive = true;
                }
            })

            if (isActive) {
                targ.classList.add('active');
            } else {
                targ.classList.remove('active');
            }
        })

        // Hide tier if gift is already in cart
        for (let i = 0; i < cartJson.items.length; i++) {
            const item = cartJson.items[i];

            if (item.properties?.["_giftTier"]) {
                const targetTier = document.querySelector(`.cart__tpgp-gift-tier--${item.properties["_giftTier"]}`);
                if (targetTier) {
                    targetTier.classList.add('hidden');
                }
            }
        }

        // Check for any visible tiers otherwise show note
        let visibleTiers = false;
        giftProductWrappers.forEach(tier => {
            if (!tier.classList.contains('hidden')) {
                visibleTiers = true;
            }
        })

        const note = document.querySelector('.cart__tpgp-note');
        if (note) {
            if (visibleTiers) {
                note.classList.add('hidden');
            } else {
                note.classList.remove('hidden');
            }
        }

        const claimGiftBtn = document.querySelector('.cart__claim-gift-btn .btn');
        if (claimGiftBtn) {
            if (visibleTiers) {
                claimGiftBtn.classList.add('shake');
            } else {
                claimGiftBtn.classList.remove('shake')
            }
        }

        const target = full_dataset[full_dataset.length - 1].target;
        let cart_total = (cartJson.total_price ? cartJson.total_price : cartJson.final_price);
        if (!cart_total) {
            cart_total = 0;
        }

        if (data.shop_currency != data.cart_currency) {
            cart_total = cart_total / exchange_rate;
        }

        const progress_value = (cart_total / target) * 100;
        const remaining = nextTarget_val - cart_total;

        if (target) {
            // Set value of progress bar
            if (progress_value >= 100){
                d.getElementById(settings.progress_bar).setAttribute('value', 100);
                d.getElementById(settings.progress_bar).parentElement.setAttribute('value', 100);
            }
            else {
                d.getElementById(settings.progress_bar).setAttribute('value', progress_value ? progress_value : 0);
                d.getElementById(settings.progress_bar).parentElement.setAttribute('value', progress_value ? progress_value : 0);
            }
        }
        else {
            message = settings.message_error;
        }

        // Display message
        d.getElementById(settings.message).innerHTML = message;

        // Update gift UI panel
        const claimBtnWrapper = document.querySelector('.cart__claim-gift-btn');
        if (canClaimGift && visibleTiers) {
            claimBtnWrapper.classList.remove('hidden');
        } else {
            claimBtnWrapper.classList.add('hidden');
        }
    }

    function init() {
        if (!container) return;

        initData();
        renderElements();
        fetchCartData();

        // Listeners for product added and cart updates
        ['cart:updated', 'ajaxProduct:added'].forEach(evt =>
            d.addEventListener(evt, fetchCartData, false)
        );
    }

    init();
})(window, document)